module.exports = __webpack_public_path__ + "static/card-logo-light-5f7c67d49a74fe2a18fe6c104d1c8dd3.svg";